/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  gs,
  ls,
  cmFTH,
//  usePagez,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';
import * as icm from './icm';
import * as ict from './ict';

//import * as icvi10 from './icvI10___Mz';
//import * as icvi17 from './icvI17___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

import * as icvBaseD10Rz from './icvBaseD10Rz';
import * as icvI1zD10To from './icvI1zD10To';
import * as icvI1zD10Co from './icvI1zD10Co';

let $_31rs = [] as _ht.ls;
//let $i10rs = [] as _ht.ls;
//let $i17rs = [] as _ht.ls;
let $i1zz = icvI1z___Mz.crtI1zz();
let $pagez = {} as _ht.dz;

export const N = () => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePz({
    ctt: 'e',
    steps: [0,0],
    _31rz: {},
    phs: 'dpy',
    dffz: icm.grtDffz({
      role: 'd',
      mode: 'e',
    })
  });

  icm.loadAtTopAsync({ // icvI1zD10RzE, icvI1zD10RzR で合わせる 
    _31r_fst: _gUserz.crt._31rz?._fst ?? 0,
    frcUdt: _sPz.udtAll,
    atrAsync: async () => {
      if (_sPz.crt.steps[0] == 0) {
        await icvI1z___Mz.load_31rLsAsync({
          i18r_fst: _gUserz.crt.i18rz?._fst ?? -1,
          sttDtm: _hmDTM.cvtFdm(_hmDTM.getTdy()),
          i1zrs1100iMnm: _sPz.crt.ctt == 'r' ? 70 : undefined,
          i1zrs1200iMnm: _sPz.crt.ctt == 'e' ? 60 : undefined,
          lwrz: {
            i191s: {
              tgt: 'i191s',
              cdn: cmFTH.vdd(false) + ` AND i191_31r1k = {_31r_key}`,
              rlcz: {
                _31r_key: '_31rs._key'
              }
            },
            _50rs: {
              tgt: '_50rs',
              cdn: cmFTH.vdd(false,false),
            },
            _51rs: {
              tgt: '_51rs',
              cdn: cmFTH.vdd(true) + ` AND _51r_31r1f = {_31r_fst}`,
              rlcz: {
                _31r_fst: '_31rs._fst'
              }
            },
          }
        })
        .then((_ls: _ht.ls) => {
          //hf.l(`icvI1zD10RzE 75: ${hf.s(_ls)}`);
          $_31rs = _ls;
        })
      }
      if (_sPz.crt.steps[0] == 1) {
//hf.l(`icvI1zD10RzR 44: here`);
        await icm.ilzPagezAsync(_sPz.crt._31rz?._fst, $pagez, undefined, _gUserz.crt.i18rz._fst);
/*
        await icvi10.loadI10rLsAsync({
          _31r_fst: _sPz.crt._31rz?._fst,
          i18r_fst: _gUserz.crt.i18rz._fst,        
          lwrType: 1,  
        })
        .then( (_ls: _ht.ls) => {
//hf.l(`icvI1zD10RzR 56: here`);
          $i10rs = _ls;
        });
        await icvi17.loadI17rLsAsync({
          _31r_fst: _sPz.crt._31rz?._fst,
          i18r_fst: _gUserz.crt.i18rz._fst,
        })
        .then( (_ls: _ht.ls) => {
//hf.l(`icvI1zD10RzR 64: here`);
          $i17rs = _ls;
        });
*/
        if (_sPz.crt.phs == 'crt') {
          $i1zz = icvI1z___Mz.crtI1zz();
          _hm.udtDz($i1zz.i1zrz, {
            i1zr_31r1f: _sPz.crt._31rz._fst,
            i1zri18r1f: _gUserz.crt.i18rz._fst,
            i1zrs1100i: _sPz.crt.ctt == 'r' ? 80 : 10,
            i1zrs1200i: _sPz.crt.ctt == 'e' ? 70 : 10,
          });
          //hf.l(`icvI1zD10Rz 106: ${$i1zz.i1zrz.i1zr_31r1f}, ${_sPz.crt._31rz._fst}`)
          icm.udtI1zzFromI18rz({
            i1zz: $i1zz,
            i18rz: _gUserz.crt.i18rz,
          });
          icm.udtI1z3z({
            i1zz: $i1zz,
            i17rs: [],
          });
        }
        else {
          await icvI1z___Mz.loadI1zrDzAsync({
            i1zr_fst: _sPz.crt.i1zr_fst,
          })
          .then( (_dz: ict.i1zz) => {
            $i1zz = _dz;
          })
        }
      }
    },
    vles: [
      _gUserz.crt._31rz?._fst,
      _gUserz.crt.i18rz?._fst,
      _sPz.crt.ctt,
      _sPz.crt.steps[0],
      _sPz.crt.i1zr_fst
    ]
  })

  return (

    cr.c(icvBaseD10Rz.N, {
      key: -10,
      sPz: _sPz,
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI1zD10To.O, {
          key: -10,
          sPz: _sPz,
          cz: {
            _31rs: $_31rs,
          }
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI1zD10Co.O, {
          key: -20,
          sPz: _sPz,
          cz: {
            i10rs: $pagez.i10rs,
            i17rs: $pagez.i17rs,
            i1zz: $i1zz,
            _601s: $pagez.hdys,
          }
        })
        : null,

      ]
    })

  );
};
